var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInformationFilled = function SvgInformationFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 0c3.278 0 6 2.722 6 6s-2.722 6-6 6-6-2.722-6-6 2.722-6 6-6m.082 4.5c-.212 0-.382.16-.382.35v4.4c.005.186.17.35.382.35.198 0 .368-.16.368-.35v-4.4a.365.365 0 0 0-.368-.35m.022-2.249a.69.69 0 0 0-.678.679.676.676 0 1 0 1.352 0 .69.69 0 0 0-.674-.679"
  })));
};
export default SvgInformationFilled;